import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import PaymentForm from "./PaymentForm";

const stripePromise = loadStripe(
  "pk_test_51Mm4i5BbiNWHJzfiKwdLrGwuhvo9zqQDTsxtKTePi6iliH6VWYL4TEVFB3N3EnnmnGyp3dlldupuIiVsuC8C8F4K00snGFrutv"
);
const CartCheckout = () => {
  return (
    <Elements stripe={stripePromise}>
      {/* <CheckoutForm /> */}
      <PaymentForm />
    </Elements>
  );
};

export default CartCheckout;
